var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UserInformationForm',{attrs:{"user":_vm.user,"readonly":!_vm.hasPermission(_vm.Permission.USERS_EDIT)}})}
var staticRenderFns = []

export { render, staticRenderFns }